import { request } from "graphql-request";
import { graphql } from "gql/gql";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const queryFnEmissionCard = (
    accessToken: string,
    data: {
        reportFiltersetUid: string | null;
    }
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            reportFiltersetUid: data.reportFiltersetUid,
        },        
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (
            // eslint-disable-next-line max-len
            data.prefilteredReports?.prefilteredBaselineReport.currentAnnualCarbonEmissionsCard.error
            // data.reports?.baselineReport?.currentAnnualCarbonEmissionsCard.error
        )
            throw new Error(
                // eslint-disable-next-line max-len
                data.prefilteredReports?.prefilteredBaselineReport.currentAnnualCarbonEmissionsCard.error
            );
        return (
            data.prefilteredReports?.prefilteredBaselineReport?.currentAnnualCarbonEmissionsCard ||
            null
        );
    });

const query = graphql(`
    query currentAnnualCarbonEmissionsCard($reportFiltersetUid:  Uuid) {
        prefilteredReports(reportFiltersetUid:  $reportFiltersetUid) {
            prefilteredBaselineReport {
                currentAnnualCarbonEmissionsCard {
                    error
                    averageEmissionsIntensity
                    totalCarbonEmissions
                }
            }
        }
    }
`);

export default queryFnEmissionCard;
